import React from 'react';
import PublicIcon from '@material-ui/icons/Public';
import DnsRoundedIcon from '@material-ui/icons/DnsRounded';
import PermMediaOutlinedIcon from '@material-ui/icons/PhotoSizeSelectActual';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';


export const countries = [
  {
    id: 'Countries',
    children: [    
      { id: 'United States', icon: <PublicIcon />, active: true, },
      { id: 'Italy', icon: <PublicIcon /> },
      { id: 'China', icon: <PublicIcon /> },
      { id: 'Russia', icon: <PublicIcon /> },
      { id: 'Canada', icon: <PublicIcon /> },
      { id: 'Australia', icon: <PublicIcon /> },
      { id: 'Germany', icon: <PublicIcon /> },
      { id: 'Spain', icon: <PublicIcon /> },
      { id: 'Argentina', icon: <PublicIcon /> },
      { id: 'Mexico', icon: <PublicIcon /> },
      { id: 'Singapore', icon: <PublicIcon /> },
      { id: 'Malaysia', icon: <PublicIcon /> },
      { id: 'Japan', icon: <PublicIcon /> },
      { id: 'Tunisia', icon: <PublicIcon /> },          
    ],
  }
  
];

export const staticMenu = {
    id: 'See Also',
    children: [
      //{ id: 'Home', icon: <PeopleIcon />, active: true },
      { id: 'Deep Dive', icon: <DnsRoundedIcon />, link: 'deepdive' },
      { id: 'Helpful Links', icon: <PermMediaOutlinedIcon /> , link: 'helpfullinks'},
      { id: 'Essentials', icon: <PublicIcon />, link: 'essentials' },
      { id: 'FAQ', icon: <SettingsEthernetIcon />, link: 'faq' },
    ],
  }

